import React, { useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import {
  MaterialIcon,
  ButtonSizeOptions,
  PrimaryButton,
  SecondaryButton
} from "@loanbossinc/component-library";
import RichTextEditor from "components/Global/RichTextEditor";

import GeneralLayout from "./components/GeneralLayout";
import DripCampaignModal from "./components/DripCampaignModal";
import Schedule from "./components/Schedule";

const Header = styled.div`
  padding: 0 49px 16px 49px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const GuidingText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Name = styled.h4`
  margin-top: 0;
  margin-bottom: 4px;
  font-size: 24px;
  font-weight: 500;
`;

const Description = styled.p`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 16px;
  color: #5F6368;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Status = styled.div`
  width: 198px;
  height: 48px;
  background: #C4C4C4;
  border-radius: 4px;
  color: #FFF;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Indicator = styled.div`
  display: flex;
  align-items: center;
  color: #5F6368;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
  .label {
    margin-right: 8px;
  }
`;

const Body = styled.div`
  border-bottom: 1px solid #DADCE0;
  .DraftEditor-root {
    min-height: 650px;
    padding: 0 16px;
  }
`;

const Title = styled.div`
  padding: 11px 16px;
  background: #005aa9;
  border-radius: 8px 8px 0px 0px;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  color: #FFFFFF;
`;

const SubjectInput = styled.input`
  width: calc(100% - 32px);
  padding: 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  border: none;
  &:focus {
    outline: none;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: Work Sans;
  padding: 24px 21px 0 21px;
`;

export const EmailDraft = props => {
  const [scheduleOpened, setScheduleOpened] = useState(false);
  const [bodyText, setBodyText] = useState("");

  const showScheduleModal = () => {
    setScheduleOpened(true);
  };

  const closeScheduleModal = () => {
    setScheduleOpened(false);
  };

  const onEditorStateChange = change => {
    setBodyText(change);
  };

  return (
    <GeneralLayout>
      <Header>
        <GuidingText>
          <Name>Campaign Name</Name>
          <Description>Created on Month DD, YYYY</Description>
        </GuidingText>
        <ButtonsContainer>
          <Status>DRAFTING</Status>
          <Indicator>
            <span className="label">Draft email</span>
            <MaterialIcon iconName="drafts" />
          </Indicator>

        </ButtonsContainer>
      </Header>
      <Body>
        <Title>Campaign Title</Title>
        <SubjectInput type="text" placeholder="Subject" />
        <RichTextEditor
          htmlString={bodyText}
          handleUpdate={onEditorStateChange}
          maxColumns={6}
          maxLength={1000}
        />
      </Body>

      <Footer>
        <SecondaryButton
          label="Schedule"
          size={ButtonSizeOptions.smFluid}
          style={{ marginRight: 16, width: 132 }}
          onClick={showScheduleModal}
        />
        <PrimaryButton
          label="Save"
          size={ButtonSizeOptions.smFluid}
          onClick={() => {}}
          style={{ width: 132 }}
        />
      </Footer>

      {scheduleOpened && (
        <DripCampaignModal
          isOpen={scheduleOpened}
          maxWidth={false}
          title="Schedule your email"
          onClose={closeScheduleModal}
          PaperProps={{ style: { width: "812px", height: "367px" } }}
        >
          <Schedule
            onCancel={closeScheduleModal}
            onSchedule={() => {}}
          />
        </DripCampaignModal>
      )}
    </GeneralLayout>
  );
};

const mapStateToProps = ({ authentication }) => ({
  authentication
});

export default compose(
  connect(mapStateToProps, null)
)(EmailDraft);
